const React = require('react');
const PropTypes = require('prop-types');
const offset = require('mucss/offset');
const q = require('queried');
const ReactCSSTransitionGroup = require('react-addons-css-transition-group');
const emit = require('emmy/emit');

const Swiper = require('swiper');
const { STATUSES } = require('./consts');
const _ = require('../i18n');
const { QUIZ_TYPES } = require('../utils');
const { launchInstagramWidgets } = require('../instagram-iframe');
const likelyWidget = require('../likely-widget');

function getIconHTML(name) {
  return `&#x${window.kudago.icons[name]};`;
}

function isMedia(question) {
  return question.answers.some((a) => a.content.includes('image'));
}

const TRANSITION_DURATION = 500;
function QuizTransition(props) {
  return (
    <ReactCSSTransitionGroup
      transitionName="quizTransition"
      transitionAppear
      transitionAppearTimeout={TRANSITION_DURATION}
      transitionEnterTimeout={TRANSITION_DURATION}
      transitionLeave={false}
    >
      {/* eslint-disable-next-line react/destructuring-assignment */}
      {props.children}
    </ReactCSSTransitionGroup>
  );
}

class QuizView extends React.PureComponent {
  componentDidUpdate(prevProps) {
    // eslint-disable-next-line react/destructuring-assignment
    const stepChanged = prevProps.currentQuestion !== this.props.currentQuestion
    // eslint-disable-next-line react/destructuring-assignment
      || prevProps.status !== this.props.status;

    if (stepChanged) {
      this.checkAndUpdateScroll();
    }

    // there can be instagram widget in comment for the answer
    // eslint-disable-next-line react/destructuring-assignment
    if (stepChanged || prevProps.givenAnswers !== this.props.givenAnswers) {
      launchInstagramWidgets();
    }
  }

  checkAndUpdateScroll() {
    const quiz = q('.quiz');

    if (!quiz) {
      return;
    }

    const doc = document.documentElement;
    const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    const elementOffset = offset(quiz).top;

    if (scrollTop > elementOffset) {
      quiz.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.status === STATUSES.start) {
      return null;
      // eslint-disable-next-line react/destructuring-assignment
    } if (this.props.status === STATUSES.finished) {
      // eslint-disable-next-line react/destructuring-assignment
      const result = this.props.getResult();
      const { location } = window;
      if (window.history) {
        window.history.replaceState(null, null, `?result=${result.id}`);
      }
      const sharingUrl = `${location.protocol}//${location.hostname}${location.pathname}?result=${result.id}`;
      const title = _.interpolate(_('My result: "%s" | %s'), [result.name, document.title]);
      const image = result.image
        ? `${location.protocol}//${location.hostname}${result.image.url}`
        : likelyWidget.getOgProp('image');

      const createSwiper = (swiperElement) => new Swiper(swiperElement, {
        loop: true,
        navigation: {
          nextEl: q('.quiz-result .swiper-button-next', swiperElement),
          prevEl: q('.quiz-result .swiper-button-prev', swiperElement),
        },
      });

      setTimeout(() => {
        const swiperElement = document.querySelector('.quiz-result .swiper-container');
        return new Promise(() => {
          if (swiperElement) {
            // eslint-disable-next-line no-promise-executor-return
            return createSwiper(swiperElement);
          }

          const observer = new MutationObserver(() => {
            if (swiperElement) {
              createSwiper(swiperElement);
              observer.disconnect();
            }
          }).observe(document.body, { childList: true, subtree: true });
        });
      }, 0);

      return (
        <QuizTransition>
          <div className="quiz" key="results">
            <div className="h1 quiz-resultTitle" hidden={!result.name}>
              {result.name}
            </div>
            <div
              className="quiz-result"
              dangerouslySetInnerHTML={{ __html: result.content }}
            />
            <div className="quiz-share" data-analytics="quiz-share">
              {_.pgettext('quiz', 'Share the result:')}
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              <div
                onClick={() => emit(document.body, 'test-share', null, true)}
                dangerouslySetInnerHTML={{
                  __html: likelyWidget({
                    title,
                    image,
                    url: sharingUrl,
                  }),
                }}
              />
            </div>
            <div className="quiz-again">
              <span className="quiz-again-container">
                <i
                  className="font-icon icon-spinner"
                  dangerouslySetInnerHTML={{ __html: getIconHTML('spinner') }}
                />
                {/* eslint-disable react/destructuring-assignment */}
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                <span
                  className="quiz-again-link"
                  onClick={this.props.refreshQuiz}
                  data-analytics="quiz-again"
                >
                  {_.pgettext('quiz', 'Try again')}
                </span>
              </span>
            </div>
          </div>
        </QuizTransition>
      );
    }

    const questionIndex = this.props.currentQuestion;
    const question = this.props.config.questions[questionIndex];
    const nextQuestion = this.props.config.questions[questionIndex + 1];
    const answerClass = isMedia(question)
      ? 'quiz-answerMedia'
      : 'quiz-answerTextual';

    const activeAnswerClass = `${answerClass}--active`;
    const givenAnswerIndex = this.props.givenAnswers[questionIndex];
    const givenAnswer = question.answers[givenAnswerIndex];
    const answers = question.answers.map((a, i) => {
      const activeClass = givenAnswerIndex === i ? activeAnswerClass : '';
      let correctnessClass = '';
      if (
        this.props.config.quizType === QUIZ_TYPES.topScore
        && givenAnswerIndex !== undefined
      ) {
        correctnessClass = Number(a.score._default)
          ? `${answerClass}--correct`
          : `${answerClass}--incorrect`;
      }

      return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
          key={a.id}
          className={`${answerClass} ${correctnessClass} ${activeClass}`}
          onClick={() => this.props.giveAnswer(questionIndex, i)}
          dangerouslySetInnerHTML={{ __html: a.content }}
        />
      );
    });
    const comment = givenAnswer !== undefined && givenAnswer.comment.trim() ? (
      <div
        className="quiz-comment"
        dangerouslySetInnerHTML={{ __html: givenAnswer.comment }}
      />
    ) : null;
    const isLastQuestion = this.props.currentQuestion === this.props.config.questions.length - 1;
    const button = isLastQuestion ? (
      <div className="quiz-next" hidden={givenAnswer === undefined}>
        {/* eslint-disable-next-line react/button-has-type */}
        <button
          className="button quiz-nextButton"
          onClick={this.props.goToNextQuestion}
          data-analytics="quiz-finish"
        >
          {_.pgettext('quiz', 'Finish quiz')}
        </button>
      </div>
    ) : (
      <div className="quiz-next" hidden={givenAnswer === undefined}>
        {/* eslint-disable-next-line react/button-has-type */}
        <button
          className="button quiz-nextButton"
          onClick={this.props.goToNextQuestion}
          data-analytics="quiz-next"
        >
          {_.pgettext('quiz', 'Next')}
        </button>
      </div>
    );

    return (
      <QuizTransition>
        <div className="quiz" key={questionIndex}>
          <div className="quiz-item">
            <div className="quiz-counter">
              {questionIndex + 1}
              /
              {this.props.config.questions.length}
            </div>
            <div
              className="quiz-question"
              dangerouslySetInnerHTML={{ __html: question.content }}
            />
            <div
              className="quiz-next-question"
              dangerouslySetInnerHTML={{ __html: nextQuestion && nextQuestion.content || '' }}
            />
            <div className={`quiz-answers ${givenAnswer !== undefined ? 'quiz-answers--voted' : ''}`}>
              {answers}
            </div>
            {comment}
            {button}
          </div>
        </div>
      </QuizTransition>
    );
  }
}

QuizView.propTypes = {
  currentQuestion: PropTypes.number.isRequired,
  config: PropTypes.object.isRequired,
  givenAnswers: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  goToNextQuestion: PropTypes.func.isRequired,
  getResult: PropTypes.func.isRequired,
  refreshQuiz: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  giveAnswer: PropTypes.func.isRequired,
};

module.exports = QuizView;
